export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "Language": "pl-PL",
    "Messages": {
        "3": "",
        "5": "",
        "10": "",
        " Elementy do uzupełnienia w tekście zamieszczamy pomiędzy zdefiniowanymi znacznikami %$dowolna_nazwa$%.": "",
        " godz.": "",
        " opublikowanych": "",
        " użytkowników.": "",
        "-": "",
        "%$ – znacznik otwierający tag": "",
        "%0": "",
        "${item.name}": "",
        "$% - znacznik zamykający tag": "",
        "Aby dodawać członków zespołu musisz najpierw zapisać formularz.": "",
        "Aby dodawać stanowiska musisz najpierw zapisać formularz.": "",
        "Aby dodawać użytkowników do szkolenia musisz najpierw zapisać formularz.": "",
        "Aby dodawać użytkowników do ścieżki szkoleniowej musisz najpierw zapisać formularz.": "",
        "Aby dodawać użytkowników do terminu musisz najpierw zapisać formularz.": "",
        "Aby dodawać wydziały musisz najpierw zapisać formularz.": "",
        "Aby dodawać zespół do szkolenia musisz najpierw zapisać formularz.": "",
        "Aby dodawać zespół do ścieżki szkoleniowej musisz najpierw zapisać formularz.": "",
        "Aby móc zapisać element szkolenia, powinien on posiadać przynajmniej jeden opublikowany slajd.": "",
        "Aby zobaczyć aktualny podgląd certyfikatu kliknij Zapisz.": "",
        "Adres strony": "",
        "Adres URL Webinaru": "",
        "Adresy email": "",
        "Akceptuj": "",
        "Akcja zakończona niepowodzeniem dla: ": "",
        "Akcje": "",
        "Aktualizacja wyników szkolenia użytkowników została dodana do kolejki zadań.": "",
        "Aktualny": "",
        "Aktywne": "",
        "Aktywność": "",
        "Angielski": "",
        "Ankieta po szkoleniu": "",
        "Ankieta przed szkoleniem": "",
        "Anuluj": "",
        "Anuluj wszystkie wprowadzone zmiany": "",
        "Aranżacja domyślna": "",
        "Aranżacja została dodana.": "",
        "Aranżacja została zaktualizowana.": "",
        "Archiwalne elementy szkolenia": "",
        "Archiwizuj": "",
        "Archiwizuj materiał lekcji": "",
        "Archiwizuj materiał testu": "",
        "Archiwizuj stronę": "",
        "Archiwum": "",
        "Audio": "",
        "Audio z biblioteki": "",
        "Autor": "",
        "Autor spotkania": "",
        "Autor szkolenia": "",
        "Biały": "",
        "Biblioteka": "",
        "Bloki": "",
        "Blokowanie użytkowników": "",
        "Blokowanie użytkowników szkoleń": "",
        "Błędnie określona liczba, sprawdź liczbę opublikowanych materiałów.": "",
        "Błędny format adresu e-mail": "",
        "brak": "",
        "Brak": "",
        "Brak dostępu do szkoleń": "",
        "Brak kategorii": "",
        "Brak kategorii nadrzędnej": "",
        "Brak kluczy": "",
        "Brak możliwości zmiany spotkania po utworzeniu terminu.": "",
        "Brak opisu": "",
        "Brak tematu": "",
        "Brak typu zadania": "",
        "Brak uprawnień do zaliczania elementów.": "",
        "Brak wyników": "",
        "Certyfikat": "",
        "Certyfikat jest opublikowany": "",
        "Certyfikat nie jest opublikowany": "",
        "Certyfikat przygotowany jest do formatu A4. Wyświetlany podgląd stanowi jedynie widok roboczy. Docelowy wygląd certyfikatu będzie powiązany z właściwymi danymi szkolenia oraz użytkownika.": "",
        "Certyfikat został dodany.": "",
        "Certyfikat został usunięty.": "",
        "Certyfikat został zaktualizowany.": "",
        "Certyfikat-podgląd": "",
        "Certyfikatów": "",
        "Certyfikaty": "",
        "Chat": "",
        "Chat z raportami szkoleń": "",
        "Chcesz przywrócić temat wraz z elementami?": "",
        "Chcesz przywrócić ten element?": "",
        "Cykliczne": "",
        "Cykliczność": "",
        "Cytat": "",
        "Cytaty": "",
        "Czarny": "",
        "Czas": "",
        "Czas dostępu do szkolenia (liczba dni)": "",
        "Czas dostępu do ścieżki (liczba dni)": "",
        "Czas na realizację szkolenia (liczba dni)": "",
        "Czas na realizację ścieżki (liczba dni)": "",
        "Czas trwania": "",
        "Czas ważności certyfikatu (liczba dni)": "",
        "czerwcu": "",
        "czerwiec": "",
        "Czerwony": "",
        "Członkowie zespołu": "",
        "Czwartek": "",
        "Czy na pewno chcesz ukryć wiadomość?": "",
        "Czy na pewno chcesz zablokować użytkownika?": "",
        "Czy na pewno chcesz zkopiować szkolenie?": "",
        "Czy opublikowany": "",
        "Czy zablokować użytkownika i jego wiadomości?": "",
        "Dashboard": "",
        "Dashboard szkolenia": "",
        "Data": "",
        "Data do": "",
        "Data dodania": "",
        "Data logowania": "",
        "Data modyfikacji": "",
        "Data od": "",
        "Data opuszczenia zespołu": "",
        "Data ostatniej aktualizacji danych": "",
        "Data ostatniej edycji": "",
        "Data otrzymania punktów": "",
        "Data otrzymania punktów do": "",
        "Data otrzymania punktów od": "",
        "Data publikacji": "",
        "Data rozpoczęcia": "",
        "Data rozpoczęcia spotkania od": "",
        "Data utworzenia": "",
        "Data uzyskania certyfikatu": "",
        "Data uzyskania do": "",
        "Data uzyskania od": "",
        "Data zakończenia": "",
        "Data zakończenia zapisów do": "",
        "Data zakończenia zapisów od": "",
        "Data zakończenia zapisów: ": "",
        "Data zakónczenia spotkania do": "",
        "Data zaliczenia": "",
        "Data zapisu": "",
        "Daty dostępów dla użytkowników ze ścieżki szkoleniowej są nadrzędne, daty dostępów dodane w szkoleniu nie będą brane pod uwagę.": "",
        "Długi tekst": "",
        "Długość treści": "",
        "Do akceptacji": "",
        "Do szkolenia nie przypisano jeszcze żadnych użytkowników.": "",
        "Do szkolenia nie przypisano jeszcze żadnych zespołów.": "",
        "Do ścieżki szkoleniowej nie przypisano jeszcze żadnych użytkowników.": "",
        "Do ścieżki szkoleniowej nie przypisano jeszcze żadnych zespołów.": "",
        "Do terminu nie przypisano jeszcze żadnych użytkowników.": "",
        "Dodaj": "",
        "Dodaj certyfikat": "",
        "Dodaj do zespołu": "",
        "Dodaj element": "",
        "Dodaj kafelek": "",
        "Dodaj kategorie": "",
        "Dodaj kategorię": "",
        "Dodaj lekcję": "",
        "Dodaj lekcję SCORM": "",
        "Dodaj lekcję Wideo": "",
        "Dodaj link": "",
        "Dodaj mp3": "",
        "Dodaj nową opinie": "",
        "Dodaj obrazek": "",
        "Dodaj odpowiedź": "",
        "Dodaj odznakę": "",
        "Dodaj paczkę SCORM": "",
        "Dodaj punkty": "",
        "Dodaj pytanie": "",
        "Dodaj slajd": "",
        "Dodaj spotkanie": "",
        "Dodaj stwierdzenie": "",
        "Dodaj szkolenie": "",
        "Dodaj ścieżkę": "",
        "Dodaj temat": "",
        "Dodaj termin": "",
        "Dodaj test": "",
        "Dodaj tylko pracowników z wybranych wydziałów": "",
        "Dodaj użytkownika": "",
        "Dodaj wiersz": "",
        "Dodaj wszystkie z kategorii": "",
        "Dodaj zespół": "",
        "Dodanie certyfikatu": "",
        "Dodanie kategorii": "",
        "Dodanie lekcji": "",
        "Dodanie paczki SCORM": "",
        "Dodanie slajdów": "",
        "Dodanie spotkania": "",
        "Dodanie szkolenia": "",
        "Dodanie ścieżki szkoleniowej": "",
        "Dodanie terminu": "",
        "Dodanie testu": "",
        "Dodatkowe uwagi": "",
        "Dodawanie odznaki": "",
        "Dodawanie punktów": "",
        "Dokument nie jest jeszcze nigdzie opublikowany.": "",
        "Dopasowanie": "",
        "Dopasuj do kategorii": "",
        "Dopasuj do obrazka": "",
        "Dostęp do": "",
        "Dostęp do terminu": "",
        "dostęp indywidualny": "",
        "Dostęp od": "",
        "Dostęp przyznany przez zespół": "",
        "Dostęp przyznany ręcznie": "",
        "dostęp z zespołu": "",
        "Dostępne są tylko wydarzenia, które mają włączoną opcję \"Wydarzenie dostępne tylko w module spotkań\"": "",
        "Dostępy": "",
        "Działania masowe": "",
        "E-learning": "",
        "E-mail": "",
        "Edycja certyfikatu": "",
        "Edycja jest obecnie niedostępna, ponieważ trwa proces przetwarzania danych związanych z terminami szkoleń": "",
        "Edycja kategorii": "",
        "Edycja lekcji": "",
        "Edycja odznaki": "",
        "Edycja paczek SCORM": "",
        "Edycja punktów": "",
        "Edycja slajdów": "",
        "Edycja spotkania": "",
        "Edycja szkolenia": "",
        "Edycja ścieżki szkoleniowej": "",
        "Edycja terminu": "",
        "Edycja testu": "",
        "Edytuj": "",
        "Edytuj członka grupy": "",
        "Edytuj datę dostępu": "",
        "Edytuj kategorie": "",
        "Edytuj lekcje": "",
        "Edytuj lekcje SCORM": "",
        "Edytuj lekcje wideo": "",
        "Edytuj link": "",
        "Edytuj temat": "",
        "Edytuj test": "",
        "Edytuj użytkownika": "",
        "Edytuj wpis": "",
        "Eksport do Excela": "",
        "element": "",
        "Element": "",
        "Element grupujący": "",
        "Element jest wymagany": "",
        "element niewymagany": "",
        "Element opublikowany": "",
        "Element szkolenia rozpoczęty przez użytkowników": "",
        "Element szkolenia ukończony przez użytkowników": "",
        "element wymagany": "",
        "Element wymagany": "",
        "Element został dodany.": "",
        "Element został przywrócony.": "",
        "Element został zaktualizowany.": "",
        "elementów": "",
        "elementy": "",
        "Elementy": "",
        "Elementy szkolenia": "",
        "Elementy szkolenia użytkownika": "",
        "Elementy szkolenia użytkownika: ${selectedUserData}": "",
        "Email": "",
        "Filtry": "",
        "Formularz": "",
        "Generator linku": "",
        "Generuj nowy link": "",
        "Generuj treść slajdu": "",
        "grudniu": "",
        "grudzień": "",
        "Grywalizacja": "",
        "Historia wygenerowanych treści.": "",
        "ID": "",
        "Ikona": "",
        "Imię": "",
        "Imię i nazwisko": "",
        "Imię i Nazwisko": "",
        "Import slajdów z PDF": "",
        "Importuj": "",
        "Importuj slajdy": "",
        "Informacje dodatkowe": "",
        "Jasny niebieski": "",
        "Jednokrotnego wyboru": "",
        "Jeszcze nie ma kategorii.": "",
        "Język": "",
        "Katalog linków": "",
        "Kategoria": "",
        "Kategoria materiałów": "",
        "Kategoria materiału": "",
        "Kategoria nadrzędna": "",
        "Kategoria slajdu": "",
        "Kategoria spotkania": "",
        "Kategoria szkolenia": "",
        "Kategoria wyszukiwanego materiału": "",
        "Kategoria została dodana.": "",
        "Kategoria została usunięta.": "",
        "Kategoria została zaktualizowana.": "",
        "Kategoria: ": "",
        "Kategorie": "",
        "Kategorie materiałów": "",
        "Kategorie spotkań": "",
        "Kategorie szkoleń": "",
        "Klucze": "",
        "Kobieta": "",
        "Kolejność zaliczania elementów": "",
        "Kolor tła": "",
        "Komunikat po niezaliczeniu testu": "",
        "Komunikat po otrzymaniu odznaki": "",
        "Komunikat po zaliczeniu testu": "",
        "Konfiguracja": "",
        "Konto aktywne": "",
        "Koordynator": "",
        "Koordynatorów": "",
        "Koordynowane szkolenia:": "",
        "Kopiuj pole": "",
        "Kreator szkoleń": "",
        "Kreator Szkoleń AI": "",
        "Krótki opis": "",
        "Krótki tekst": "",
        "kwiecień": "",
        "kwietniu": "",
        "Legenda": "",
        "Lekcja": "",
        "Lekcja do powtórzenia": "",
        "Lekcja może zawierać tylko materiały opisowe": "",
        "Lekcja może zawierać tylko materiały opisowe lub materiały video": "",
        "Lekcja SCORM ukryta": "",
        "Lekcja SCORM została dodana.": "",
        "Lekcja SCORM została zaktualizowana.": "",
        "Lekcja ukryta": "",
        "Lekcja wideo została dodana.": "",
        "Lekcja wideo została zaktualizowana.": "",
        "Lekcja została dodana.": "",
        "Lekcja została zaktualizowana.": "",
        "Lekcje": "",
        "Lekcje video": "",
        "Liczba dni co ile wysyłane jest powiadomienie": "",
        "Liczba dni do zakończenia szkolenia przy której zostanie wysłane powiadomienie": "",
        "Liczba dni od jakiej użytkownik otrzyma powiadomienie": "",
        "Liczba elementów": "",
        "Liczba elementów do uzupełnienia": "",
        "Liczba kategorii": "",
        "Liczba koordynatorów": "",
        "Liczba koordynowanych szkoleń: %0": "",
        "Liczba miejsc": "",
        "Liczba odpowiedzi": "",
        "Liczba opublikowanych elementów (zakładka Zawartość) musi być większa lub równa ustawionej liczbie wyświetlanych elementów (zakładka Ustawienia)": "",
        "Liczba podejść": "",
        "Liczba podejść nie może być mniejsza niż 0": "",
        "Liczba powtórzeń": "",
        "Liczba punktów": "",
        "Liczba punktów nie może być liczbą ujemną": "",
        "Liczba pytań": "",
        "Liczba spotkań": "",
        "Liczba szkoleń": "",
        "Liczba szkoleń w ścieżce": "",
        "Liczba uczestników": "",
        "Liczba użytkowników": "",
        "Liczba użytkowników szkolenia": "",
        "Liczba wyświetlanych elementów": "",
        "Liczba zapisanych": "",
        "Liczba zapisanych osób": "",
        "Liczba zapisanych/Liczba dostępnych miejsc: ": "",
        "Lider": "",
        "Limit czasu (minuty)": "",
        "Limit czasu nie może być mniejszy niż 0 minut": "",
        "Limit miejsc": "",
        "Linia ciągła": "",
        "Linia falująca": "",
        "Linia kreskowana": "",
        "Linia kropkowana": "",
        "Link": "",
        "Link do strony": "",
        "Link do wybranej strony serwisu": "",
        "Link do zewnętrznej strony": "",
        "Link przycisku": "",
        "Link został dodany.": "",
        "Link został skopiowany.": "",
        "Link został usunięty.": "",
        "Link został wygenerowany.": "",
        "Link został zaktualizowany.": "",
        "lipcu": "",
        "lipiec": "",
        "Lista": "",
        "Lista certyfikatów": "",
        "Lista elementów": "",
        "Lista jest pusta": "",
        "Lista koordynatorów": "",
        "Lista paczek SCORM": "",
        "Lista rezerwowa": "",
        "Lista spotkań": "",
        "Lista szkoleń": "",
        "Lista ścieżek szkoleniowych": "",
        "Lista uczestników": "",
        "Lista wyboru": "",
        "Lista zapisanych": "",
        "Lista zespołów": "",
        "listopad": "",
        "listopadzie": "",
        "Log błędu": "",
        "Log z aktywności": "",
        "Logi aktywności zostały wyczyszczone": "",
        "Login": "",
        "Logo": "",
        "Losowa kolejność elementów": "",
        "luty": "",
        "lutym": "",
        "maj": "",
        "maju": "",
        "Maksymalna liczba podejść to 500": "",
        "Maksymalna liczba punktów": "",
        "Maksymalna limit czasu to 500 minut": "",
        "marcu": "",
        "marzec": "",
        "Masz niezapisane zmiany w materiałach. Zapisz je lub usuń aby móc zapisać element szkolenia.": "",
        "Materiał opisowy": "",
        "Materiał wideo": "",
        "Materiały szkoleniowe": "",
        "Max: 250 znaków": "",
        "Mężczyzna": "",
        "Miniaturka": "",
        "Miniaturka wideo": "",
        "Minimalny czas oglądania potrzebny do zaliczenia elementu (hh:mm:ss)": "",
        "Moduły": "",
        "Monitor aktywności": "",
        "Multimedia": "",
        "Nadpisz wersję lekcji": "",
        "Nadpisz wersję lekcji scorm": "",
        "Nadpisz wersję lekcji wideo": "",
        "Nadpisz wersję linku": "",
        "Nadpisz wersję testu": "",
        "Najnowsze": "",
        "Nazwa": "",
        "Nazwa aranżacji": "",
        "Nazwa certyfikatu": "",
        "Nazwa elementu": "",
        "Nazwa grupy": "",
        "Nazwa kategorii": "",
        "Nazwa koordynatora": "",
        "Nazwa lekcji": "",
        "Nazwa odznaki": "",
        "Nazwa odznaki dla użytkownika": "",
        "Nazwa paczki": "",
        "Nazwa paczki SCORM": "",
        "Nazwa pliku": "",
        "Nazwa pokoju": "",
        "Nazwa pola": "",
        "Nazwa przycisku": "",
        "Nazwa slajdu": "",
        "Nazwa spotkania": "",
        "Nazwa spotkania: ": "",
        "Nazwa szkolenia": "",
        "Nazwa ścieżki": "",
        "Nazwa terminu": "",
        "Nazwa testu": "",
        "Nazwa użytkownika": "",
        "Nazwa zespołu": "",
        "Nazwisko": "",
        "nie": "",
        "Nie": "",
        "Nie można ustawić dat dostępów dla szkoleń cyklicznych.": "",
        "Nie można usunąć kategorii do ktorej są przypisane elementy.": "",
        "Nie podano": "",
        "Nie podano nazwy poprzedniego elementu.": "",
        "Nie podano nazwy poprzedniej kategorii.": "",
        "Nie podano odpowiedzi dla ostatniego elementu.": "",
        "Nie udało się pobrać listy aranżacji": "",
        "Nie udało się pobrać listy kategorii": "",
        "Nie udało się pobrać listy modułów": "",
        "Nie udało się pobrać listy ról": "",
        "Nie udało się pobrać listy stanowisk": "",
        "Nie udało się pobrać listy stron": "",
        "Nie udało się pobrać listy typów materiałów": "",
        "Nie udało się pobrać listy wydziałów": "",
        "Nie wybrano ankiety": "",
        "Nie wybrano paczki.": "",
        "Nie wybrano strony": "",
        "Nie wybrano użytkownika.": "",
        "Nie wybrano żadnego użytkownika.": "",
        "Nie wypełniono poprzedniego wiersza.": "",
        "Nie zdefiniowano żadnych ról.": "",
        "Nie znaleziono elementu.": "",
        "Nie znaleziono żadnych linków.": "",
        "Nie znaleziono żadnych szkoleń dla tego zespołu.": "",
        "Nie znaleziono żadnych użytkowników.": "",
        "Nie znaleziono żadnych wyników.": "",
        "Niebieski": "",
        "Niedziela": "",
        "Nieobecny": "",
        "Nieopublikowane": "",
        "Nierozpoczęli": "",
        "Nierozpoczęty": "",
        "Niezaliczenie testu jest równoznaczne z potwierdzeniem obecności użytkownika": "",
        "Niezaliczone": "",
        "Niezaliczony": "",
        "Niezaliczyło": "",
        "Niżej": "",
        "Nowe połączenie": "",
        "Nowy materiał": "",
        "O szkoleniu": "",
        "Obecność": "",
        "Obecność została potwierdzona.": "",
        "Obecny": "",
        "Obrazek": "",
        "Obrazek wyróżniający": "",
        "Obsługa progu przez platformę": "",
        "Ocena offline": "",
        "Oczekuje na akceptację": "",
        "Odpowiedzi": "",
        "Odpowiedź": "",
        "Odrzucone": "",
        "Odznaka została dodana.": "",
        "Odznaka została zaktualizowana.": "",
        "Odznaki": "",
        "Ogólne": "",
        "Opiekun ścieżki": "",
        "Opis": "",
        "Opis kategorii": "",
        "Opis obrazka": "",
        "Opis spotkania": "",
        "Opis szkolenia": "",
        "Opis zespołu": "",
        "Opublikowane": "",
        "Opublikowany": "",
        "Opublikuj": "",
        "Opublikuj materiał": "",
        "Opublikuj ścieżkę szkoleniową aby móc dodać szkolenia": "",
        "Osoba odpowiedzialna": "",
        "Ostatnio aktualizowane": "",
        "Ostatnio oglądane": "",
        "Otwórz stronę w nowym oknie": "",
        "Otwórz w nowym oknie": "",
        "Oznacz wszystkie elementy szkolenia jako zaliczone": "",
        "Paczka SCORM została dodana.": "",
        "Paczka SCORM została zaktualizowana.": "",
        "Paczka została usunięta.": "",
        "Paczki SCORM": "",
        "październik": "",
        "październiku": "",
        "Piątek": "",
        "Pionowo": "",
        "Plik PDF": "",
        "Po dodaniu szkoleń nie można zmienić publikacji.": "",
        "Po ustawieniu dat dostępów dla użytkowników w ścieżce będą one nadrzędne, daty dostępów dodane w szkoleniu nie będą brane pod uwagę.": "",
        "Po ustawieniu indywidualnych dat dostępów dla użytkowników będą one nadrzędne, daty dostępów z zespołów nie będą brane pod uwagę.": "",
        "Pobierz certyfikat": "",
        "Podaj uwagi do treści, która ma zostać wygenerowana. Przykład: \"Używaj symboli matematycznych\".": "",
        "Podany adres e-mail został już dodany": "",
        "Podejście do elementu zostało zresetowane.": "",
        "Podgląd": "",
        "Podlega ocenie": "",
        "Podpis": "",
        "Podstawowe": "",
        "Podstawowy": "",
        "Podtytuł": "",
        "Podwójna linia ciągła": "",
        "Pojedyńcza, prosta, ciągła linia": "",
        "Pola takie jak \"Nazwa slajdu\", \"Kategoria materiału\", \"Typ materiału\" są uwzględniane przy automatycznym generowaniu treści, dlatego konieczne jest ich wypełnienie.": "",
        "Pole skopiowane": "",
        "Polski": "",
        "Połącz w pary": "",
        "Poniedziałek": "",
        "Poprawna odpowiedź": "",
        "Posiadasz niezapisane materiały": "",
        "Postęp": "",
        "Postęp (%)": "",
        "Postępy": "",
        "Postępy użytkowników": "",
        "Potwierdzenie archiwizacji": "",
        "Potwierdzenie archiwizacji. Archiwizacja tematu spowoduje zarchiwizowanie przypisanych do niego lekcji": "",
        "Potwierdzenie przywrócenia szkolenia": "",
        "Potwierdzenie publikacji": "",
        "Potwierdzenie resetu podejścia do elementu szkolenia": "",
        "Potwierdzenie resetu podejścia do szkolenia": "",
        "Potwierdzenie ukrycia": "",
        "Potwierdzenie usunięcia": "",
        "Potwierdzenie usunięcia.": "",
        "Potwierdź akceptację": "",
        "Potwierdź usunięcie": "",
        "Potwierdź wyczyszczenie logów": "",
        "Potwierdź zapis do aktualnej wersji": "",
        "Powiadomienia": "",
        "Powiadomienia z linkiem rejestracyjnym nie zostaną wysłane, ponieważ ten typ powiadomień nie jest obecnie włączony w platformie.": "",
        "Powiadomienie dla administratora chatu o nowych wiadomościach": "",
        "Powiadomienie dla użytkownika o nowych wiadomościach na chacie": "",
        "Powiadomienie o oczekującym szkoleniu": "",
        "Powiadomienie o zbliżającym się zakończeniu szkolenia": "",
        "Powiązane stanowiska": "",
        "Powiązane wydziały": "",
        "Powód": "",
        "Powrót": "",
        "Poziomo": "",
        "Pozwól kontynuować na obecnej wersji": "",
        "Prawda-Fałsz": "",
        "Produkcyjne": "",
        "Profil koordynatora": "",
        "Program": "",
        "Program szkolenia": "",
        "Próg": "",
        "Próg zaliczenia (%)": "",
        "Przeglądanie logów aktywności": "",
        "Przeglądnij logi": "",
        "Przenieś niżej": "",
        "Przenieś wyżej": "",
        "przez": "",
        "Przycisk \"zobacz wszystkie\" znajdujący się przy bloczku, będzie przekierowywał na wybraną stronę z szkoleniami. Jeśli strona nie zostanie wybrana zostanie on ukryty.": "",
        "Przypisz użytkowników do terminu spotkania, aby móc ich wyszukać.": "",
        "Przypisz zespoły do terminu spotkania, aby móc je wyszukać.": "",
        "Przywrócić użytkownika i jego wiadomości?": "",
        "Przywrócić wiadomość?": "",
        "Przywróć": "",
        "Przywróć użytkownika": "",
        "Przyznawanie punktów": "",
        "Publikacja": "",
        "Publikacja i przypisane szkolenia zostały usunięte.": "",
        "Publikacja została dodana.": "",
        "Publikuj na stronie": "",
        "Publikuj spotkanie": "",
        "Publikuj szkolenie": "",
        "Publikuj ścieżkę szkoleniową": "",
        "Publikuj termin": "",
        "Punkty": "",
        "Punkty za ukończenie": "",
        "Punkty zostały dodane.": "",
        "Punkty zostały zaktualizowane. Zmiana dotyczy tylko nowo zdobytych punktów.": "",
        "Pytania i odpowiedzi": "",
        "Pytanie": "",
        "Pytanie i odpowiedzi": "",
        "Raporty": "",
        "Reset podejścia do szkolenia": "",
        "Resetowanie podejść": "",
        "Resetowanie podejść użytkowników": "",
        "Resetuj": "",
        "Rezygnacja": "",
        "Role zespołu": "",
        "Rozpoczęcie spotkania": "",
        "Rozpoczęcie szkolenia": "",
        "Scorm": "",
        "SCORM": "",
        "Sekcje dla gości": "",
        "Sekcje dla zalogowanych": "",
        "Sekcje wspólne": "",
        "Serie kresek lub fragmentów linii": "",
        "Serie kropek": "",
        "sierpień": "",
        "sierpniu": "",
        "Skopiuj szkolenie": "",
        "Slajd do powtórzenia": "",
        "Slajd z materiałów szkoleniowych": "",
        "Slajd został dodany.": "",
        "Slajd został usunięty.": "",
        "Slajd został wygenerowany.": "",
        "Slajd został zaktualizowany.": "",
        "Slajdy": "",
        "Slajdy zostały zaimportowane.": "",
        "Sobota": "",
        "Spotkania": "",
        "Spotkanie": "",
        "Spotkanie do": "",
        "Spotkanie jest zarchiwizowane.": "",
        "Spotkanie od": "",
        "Spotkanie zostało dodane.": "",
        "Spotkanie zostało usunięte.": "",
        "Spotkanie zostało zaktualizowane.": "",
        "Sprawdź poprawność wprowadzonych danych. Po zapisaniu kolumna Zaliczenie testu nie będzie edytowalna, ponieważ zostanie wygenerowany certyfikat. Czy zapisać dane?": "",
        "Stan": "",
        "Standard": "",
        "Standard 1.2": "",
        "Standard 2004": "",
        "Standard nieznany": "",
        "Stanowiska": "",
        "Stanowisko": "",
        "Stanowisko zostało dodane.": "",
        "Stanowisko zostało usunięte.": "",
        "Status": "",
        "Status aranżacji został zmieniony.": "",
        "Status dokumentu został zmieniony.": "",
        "Status paczki został zmieniony.": "",
        "Status został zmieniony dla ": "",
        "Strona": "",
        "Strona %0": "",
        "Strona lekcji opublikowana": "",
        "Strona lekcji SCORM opublikowana": "",
        "Strona szkolenia ukryta": "",
        "Strona testu opublikowana": "",
        "Strona została zarchiwizowana.": "",
        "Stwierdzenia": "",
        "styczeń": "",
        "styczniu": "",
        "Symbol": "",
        "Symbol lekcji": "",
        "Symbol może składać się tylko z małych liter, cyfr oraz znaku - ": "",
        "Symbol strony spotkania": "",
        "Symbol strony szkolenia": "",
        "Symbol testu": "",
        "Synchronizuj": "",
        "Szary": "",
        "Szczegóły": "",
        "Szczegóły szkolenia": "",
        "Szkic": "",
        "szkolenia": "",
        "Szkolenia": "",
        "szkolenie": "",
        "Szkolenie": "",
        "Szkolenie cykliczne": "",
        "Szkolenie jest puste": "",
        "Szkolenie może występować tylko w jednej ścieżce. To szkolenie zostało już dodane do ścieżki: {0}": "",
        "Szkolenie w liczbach": "",
        "Szkolenie zostało dodane.": "",
        "Szkolenie zostało przywrócone.": "",
        "Szkolenie zostało skopiowane": "",
        "Szkolenie zostało zaktualizowane.": "",
        "Szkolenie zostało zaliczone. Nie można go edytować.": "",
        "Szkolenie zostało zarchiwizowane.": "",
        "Szkolenie zostało zarchiwizowane. Aby je wyświetlić, należy przywrócić szkolenie z archiwum.": "",
        "Szkoleniowe": "",
        "szkoleń": "",
        "Szkoleń": "",
        "Ścieżka": "",
        "Ścieżka cykliczna": "",
        "Ścieżka już jest opublikowana.": "",
        "Ścieżka szkoleniowa": "",
        "Ścieżka szkoleniowa została dodana.": "",
        "Ścieżka szkoleniowa została usunięta.": "",
        "Ścieżka szkoleniowa została zaktualizowana.": "",
        "Średni tekst": "",
        "Środa": "",
        "Ta aranżacja zostanie użyta jeśli nie przypisano żadnej innej aranżacji do strony.": "",
        "tak": "",
        "Tak": "",
        "Tekst do uzupełnienia": "",
        "Temat": "",
        "Tematy": "",
        "Ten element nie zawiera menu kontekstowego.": "",
        "Ten zespół nie posiada jeszcze żadnych powiązanych stanowisk": "",
        "Ten zespół nie posiada jeszcze żadnych powiązanych wydziałów": "",
        "Teraz": "",
        "Termin posiada test": "",
        "Termin spotkania: ": "",
        "Termin został dodany.": "",
        "Termin został usunięty.": "",
        "Termin został zaktualizowany.": "",
        "Terminy": "",
        "Test": "",
        "Test nie może zawierać materiałów opisowych i materiałów video": "",
        "Test ukryty": "",
        "Test został dodany.": "",
        "Test został zaktualizowany.": "",
        "Testowe": "",
        "Testy": "",
        "Tło certyfikatu": "",
        "Tło przycisku": "",
        "Tło strona 2": "",
        "To szkolenie znajduje się już w ścieżce szkoleń": "",
        "Treść": "",
        "Treść certyfikatu": "",
        "Tryb monitorowania aktywności": "",
        "Tryb monitorowania aktywności włączony.": "",
        "Tryb monitorowania aktywności wyłączony.": "",
        "Tylko liderzy": "",
        "Typ": "",
        "Typ aranżacji": "",
        "Typ elementu": "",
        "Typ linku": "",
        "Typ materiału": "",
        "Typ slajdu": "",
        "Typ spotkania": "",
        "Typy materiałów": "",
        "Tytuł": "",
        "Tytuł kafelka": "",
        "Ukryj": "",
        "Ukryj materiał": "",
        "Umożliwienie sprawdzania odpowiedzi": "",
        "Uprawnienia": "",
        "Uprawnienia do szkolenia pochodzą z terminu spotkań.": "",
        "Uprawnienia użytkownika": "",
        "Uruchom nagranie automatycznie": "",
        "Ustaw status": "",
        "Ustaw w kolejności": "",
        "Ustawienia": "",
        "Ustawienia ogólne": "",
        "Ustawienia zostały zaktualizowane.": "",
        "Usunięte": "",
        "Usuń": "",
        "Usuń element": "",
        "Usuń kafelek": "",
        "Usuń kategorię": "",
        "Usuń nie zapisany materiał z lekcji": "",
        "Usuń nie zapisany materiał z testu": "",
        "Usuń obrazek": "",
        "Usuń odpowiedź": "",
        "Usuń poprzednie wersje certyfikatu": "",
        "Usuń pytanie": "",
        "Usuń stronę": "",
        "Usuń szkolenie z ścieżki szkoleń": "",
        "Usuń wiersz": "",
        "Usuń z terminu": "",
        "Usuń ze szkolenia": "",
        "Utwórz nowy": "",
        "Uzupełnij dane dotyczące szkolenia": "",
        "Uzupełnij luki": "",
        "Uzupełnij wymagane pola.": "",
        "Użytkownicy": "",
        "Użytkownik": "",
        "Użytkownik i jego wiadomości zostały przywrócone.": "",
        "Użytkownik jest liderem zespołu": "",
        "Użytkownik nie może się zalogować dopóki konto nie jest aktywne.": "",
        "Użytkownik usunięty z zespołu": "",
        "Użytkownik z zespołu zostali dodani.": "",
        "Użytkownik został dodany do zespołu.": "",
        "Użytkownik został dodany.": "",
        "Użytkownik został przypisany do szkolenia.": "",
        "Użytkownik został przypisany do ścieżki szkoleniowej.": "",
        "Użytkownik został przypisany do terminu.": "",
        "Użytkownik został usunięty.": "",
        "Użytkownik został zablokowany, a jego wiadomości ukryte.": "",
        "Użytkownik został zaktualizowany.": "",
        "Video": "",
        "W trakcie": "",
        "W trakcie weryfikacji": "",
        "w tym ": "",
        "Wartość 0 oznacza brak limitu": "",
        "Wartość domyślna oznacza, że użytkownik może zaliczyć element od razu po odtworzeniu zasobu": "",
        "Wartość nie może byc mniejsza niż 0": "",
        "Webinar": "",
        "Wersje": "",
        "Wiadomości": "",
        "Wiadomość": "",
        "Wiadomość została przywrócona.": "",
        "Wiadomość została ukryta.": "",
        "Wideo": "",
        "Wideo z biblioteki": "",
        "Wideo zewnętrzne (URL)": "",
        "Wielokrotnego wyboru": "",
        "Witryna": "",
        "Właściwości": "",
        "Włącz ankietę": "",
        "Włącz chat": "",
        "Włącz monitorowanie aktywności": "",
        "Włącz przyznawanie punktów": "",
        "Włączenie cykliczności spowoduje usunięcie dat dostępu dla użytkowników i zespołów": "",
        "Włączona": "",
        "Wpis został usunięty.": "",
        "Wpis został zaktualizowany.": "",
        "Wprowadzenie zmian w polu \"Wybierz paczkę SCORM\" powoduje, że nadpisanie dotychczasowej wersji elementu szkolenia jest niedostępne.": "",
        "Wprowadzenie zmian w polu \"Źródło\" powoduje, że nadpisanie dotychczasowej wersji elementu szkolenia jest niedostępne.": "",
        "Wprowadzenie zmian w zakładce \"ZAWARTOŚĆ\" powoduje, że nadpisanie dotychczasowej wersji elementu szkolenia jest niedostępne.": "",
        "Wprowadzenie zmiany linku powoduje, że nadpisanie dotychczasowej wersji elementu szkolenia jest niedostępne.": "",
        "wrzesień": "",
        "wrześniu": "",
        "Wszyscy użytkownicy": "",
        "Wszystkie": "",
        "Wszystkie kategorie": "",
        "Wszystkie typy": "",
        "Wtorek": "",
        "Wybieranie katalogu jest wymagane": "",
        "Wybierz": "",
        "Wybierz aktywność": "",
        "Wybierz ankietę do wypełnienia po szkoleniu": "",
        "Wybierz ankietę do wypełnienia przed szkoleniem": "",
        "Wybierz certyfikat": "",
        "Wybierz długość generowanej treści.": "",
        "Wybierz element": "",
        "Wybierz katalog": "",
        "Wybierz kategorię": "",
        "Wybierz paczkę": "",
        "Wybierz paczkę SCORM": "",
        "Wybierz rok: ": "",
        "Wybierz stanowisko": "",
        "Wybierz stronę": "",
        "Wybierz strony": "",
        "Wybierz szkolenie": "",
        "Wybierz szkolenie ze ścieżki szkoleniowej": "",
        "Wybierz temat": "",
        "Wybierz użytkownika": "",
        "Wybierz wersję": "",
        "Wybierz wydarzenie": "",
        "Wybierz wydział": "",
        "wybierz...": "",
        "Wybór kategorii": "",
        "Wybór listy stron": "",
        "Wybór możliwy po zapisaniu zmian w teście.": "",
        "Wybór strony przekierowującej": "",
        "Wybrana wersja slajdu została wygenerowana w nieprawidłowym formacie. Nie można jej wyświetlić.": "",
        "Wybrane kategorie": "",
        "Wybrane spotkanie nie jest opublikowane": "",
        "Wybrane szkolenie nie jest opublikowane": "",
        "Wybrane wydarzenie nie jest opublikowane": "",
        "Wybrane wydarzenie nie ma włączonej opcji \"Wydarzenie dostępne tylko w module spotkań\"": "",
        "Wybranie ikony jest wymagane.": "",
        "Wybranie katalogu jest wymagane": "",
        "Wybranie statusu jest wymagane.": "",
        "Wybranie strony jest wymagane": "",
        "Wybrano %0 użytkowników.": "",
        "Wybrano jednego użytkownika.": "",
        "Wybrany certyfikat jest już nieaktualny.": "",
        "Wybrany materiał został już dodany do lekcji": "",
        "Wybrany materiał został już dodany do testu": "",
        "Wyczyść": "",
        "Wydarzenie z kalendarza": "",
        "Wydział": "",
        "Wydział został dodany.": "",
        "Wydział został usunięty.": "",
        "Wydziały": "",
        "Wymagaj kolejności zaliczania elementów": "",
        "Wymagaj odpowiedzi, aby przejść dalej": "",
        "Wymagaj pełnego odsłuchania do zaliczenia": "",
        "Wymagaj pełnego odsłuchania/obejrzenia do zaliczenia": "",
        "Wymagaj wszystkich warunków": "",
        "wymagany": "",
        "Wymagany procent musi zawierać się w przedziale 0-100": "",
        "Wymuś nowe podejście - reset wyniku": "",
        "Wynik": "",
        "Wynik (%)": "",
        "Wystapił błąd podczas kopiwaniu linku.": "",
        "Wystąpił błąd archiwizacji": "",
        "Wystąpił błąd podczas próby exportu.": "",
        "Wystąpił błąd podczas próby pobrania szczegółów.": "",
        "Wystąpił błąd podglądu": "",
        "Wystąpił błąd. Nie udało się zmienić statusu.": "",
        "Wystąpił błąd. Spróbuj ponownie później.": "",
        "Wystąpił problem z pobraniem certyfikatu": "",
        "Wystąpił problem z potwierdzeniem obecności": "",
        "Wyszukaj": "",
        "Wyszukaj użytkownika": "",
        "Wyszukaj zespół": "",
        "Wyświetl materiały": "",
        "Wyświetl popup z kontynuacją lekcji": "",
        "Wyświetlanie": "",
        "Wyżej": "",
        "z maksymalnie 240 znaków": "",
        "z maksymalnie 580 znaków": "",
        "Zaakceptowane": "",
        "Zaakceptowany": "",
        "Zaawansowane": "",
        "Zablokowany": "",
        "Zablokuj użytkownika": "",
        "zacznij pisać aby wyszukać certyfikat...": "",
        "zacznij pisać aby wyszukać kategorię...": "",
        "zacznij pisać aby wyszukać materiał...": "",
        "zacznij pisać aby wyszukać paczkę SCORM...": "",
        "zacznij pisać aby wyszukać spotkanie...": "",
        "zacznij pisać aby wyszukać stanowisko...": "",
        "zacznij pisać aby wyszukać szkolenie...": "",
        "zacznij pisać aby wyszukać użytkownika...": "",
        "zacznij pisać aby wyszukać wydarzenie...": "",
        "zacznij pisać aby wyszukać wydział...": "",
        "zacznij pisać aby wyszukać zespół...": "",
        "zacznij pisać aby wyszukać...": "",
        "Zajawka": "",
        "Zakończenie spotkania": "",
        "Zakończenie szkolenia": "",
        "Zakończenie zapisów": "",
        "Zakończony": "",
        "Zakończyło": "",
        "Zalecane wymiary 1605x450": "",
        "Zaliczenie": "",
        "Zaliczenie testu": "",
        "Zaliczenie testu jest równoznaczne z potwierdzeniem obecności i wystawieniem certyfikatu dla użytkownika": "",
        "Zaliczone": "",
        "Zaliczono wszystkie elementy szkolenia.": "",
        "Zaliczono wybrane elementy szkolenia.": "",
        "Zaliczony": "",
        "Zamknij": "",
        "Zapis nowej wersji elementu szkolenia": "",
        "Zapis został usunięty": "",
        "Zapisani": "",
        "Zapisz": "",
        "Zapisz i wróć": "",
        "Zapisz i wyślij": "",
        "Zapisz lekcję": "",
        "Zapisz lekcję scorm": "",
        "Zapisz lekcję scorm w nowej wersji": "",
        "Zapisz lekcję w nowej wersji": "",
        "Zapisz lekcję wideo": "",
        "Zapisz lekcję wideo w nowej wersji": "",
        "Zapisz link": "",
        "Zapisz link w nowej wersji": "",
        "Zapisz slajd": "",
        "Zapisz ścieżkę aby móc ją opublikować.": "",
        "Zapisz temat": "",
        "Zapisz test": "",
        "Zapisz test w nowej wersji": "",
        "Zarchiwizowane": "",
        "Zarządzaj zespołami": "",
        "Zarządzanie zespołami": "",
        "Zawartość": "",
        "Zaznacz/odznacz wszystko": "",
        "Zbliżająca się data zakończenia": "",
        "Zespół": "",
        "Zespół aktywny": "",
        "Zespół został dodany.": "",
        "Zespół został przypisany do szkolenia.": "",
        "Zespół został przypisany do ścieżki szkoleniowej.": "",
        "Zespół został przypisany do terminu.": "",
        "Zespół został usunięty.": "",
        "Zespół został zaktualizowany.": "",
        "Zewnętrzny link jest wymagany": "",
        "Zewnętrzny serwis": "",
        "Zielony": "",
        "Zmiana wersji elementu nie dotyczy użytkowników z zakończonym szkoleniem": "",
        "Zmień status": "",
        "Zmień widok": "",
        "Zresetowano podejście.": "",
        "zresetuj podejście do elementu szkolenia": "",
        "Zwrócony": "",
        "Zwykłe": "",
        "Źródło": "",
        "Żółty": ""
    }
};
